/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {trustDevice} from '../api'

export const useMutationTrustDevice = createReactQueryMutationHook('trustDevice', trustDevice)
